export default __webpack_public_path__ + "static/media/pexels-clem-onojeghuo-375882.6eab40b9.jpg";